import { Routine } from 'redux-saga-routines';
import { fetchPositionsRoutine, fetchPositionCountersRoutine, updatePositionFilterRoutine } from '../../routines';
import { IPosition } from '../../../../common/models/position/IPosition';
import { PositionFilterType } from '../../../../common/enums/PositionFilterType';
import { PositionCounts } from '../../../../common/models/position/PositionCounts';
import { updateCandidateStatusRoutine } from '../../../../containers/CandidatesBulkActions/routines';
import { mergePositionsRoutine } from '../../../../containers/MergePositions/routines';
import { IFilter } from '../../../../common/models/filter/IFilter';
import { AssignmentFilterType } from '../../../../common/enums/AssignmentFilterType';

export type PositionState = {
  counters?: PositionCounts;
  positions: IPosition[];
  total: number;
  loading: boolean;
  assignmentFilter: AssignmentFilterType;
  filter?: IFilter;
};

const initialCounters = {
  [PositionFilterType.AllPositions]: 0,
  [PositionFilterType.AllActivePositions]: 0,
  [PositionFilterType.NotStarted]: 0,
  [PositionFilterType.InProcess]: 0,
  [PositionFilterType.Complete]: 0,
  [PositionFilterType.InactivePositions]: 0
};

const initialState: PositionState = {
  positions: [],
  counters: initialCounters,
  total: 0,
  loading: true,
  assignmentFilter: AssignmentFilterType.Me
};

export const positions = (state: PositionState = initialState, { type, payload }: Routine<any>) => {
  switch (type) {
    case fetchPositionsRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case fetchPositionsRoutine.SUCCESS:
      const items = payload.reset ? payload.items : [...state.positions, ...payload.items];
      return {
        ...state,
        counters: state.counters,
        positions: items,
        total: payload.total,
        loading: false
      };
    case fetchPositionCountersRoutine.SUCCESS:
      return {
        ...state,
        counters: payload
      };
    case updateCandidateStatusRoutine.SUCCESS:
    case mergePositionsRoutine.SUCCESS:
      return {
        ...state,
        counters: state.filter ? undefined : state.counters
      };
    case fetchPositionsRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case updatePositionFilterRoutine.TRIGGER: {
      const { filter, assignmentFilter } = payload;
      return {
        ...state,
        filter,
        assignmentFilter: assignmentFilter || state.assignmentFilter
      };
    }
    default:
      return state;
  }
};
